import { useContext } from 'react'

import { Text } from '@hhgtech/hhg-components/mantine'
import { Box, BoxProps, Skeleton, Stack, useMantineTheme } from '@mantine/core'

import { AirPopulationContext } from '../context'

export const Information = (props: BoxProps) => {
  const theme = useMantineTheme()
  const { firstLoading, data } = useContext(AirPopulationContext)
  const { color = 'gray', description, informationIcon, valueColorIndex = 7 } =
    data || {}
  const IconComp =
    typeof informationIcon === 'function' ? informationIcon : null

  if (firstLoading)
    return (
      <Stack spacing={8} {...props}>
        <Skeleton height={16} radius={4} width={200} />
        <Skeleton height={16} radius={4} width={200} />
        <Skeleton height={16} radius={4} width={130} />
      </Stack>
    )
  if (!description) return null
  return (
    <Box
      sx={{
        position: 'relative',
        '.info-label': {
          '&:before': {
            content: '""',
            display: 'inline-block',
            width: 20,
          },
        },
        '.info-icon': { position: 'absolute', top: 2, left: 0 },
      }}
      {...props}
    >
      {IconComp && (
        <IconComp
          size={16}
          color={theme.colors[color]?.[valueColorIndex]}
          className="info-icon"
        />
      )}
      <Text size="p3" className="info-label">
        {description}
      </Text>
    </Box>
  )
}
